














































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Footer from "../components/Footer.vue";
import Ajax from "../lib/ajax";
import WxLogin from "../lib/wxlogin";
import newCoupon from "@/components/new-coupon.vue";

@Component({
    components: { Footer, newCoupon },
})
export default class Register extends AbpBase {
    spinShow = false;
    isNewCouponModal: boolean = false;
    registerModel = {
        name: "",
        surname: "",
        userName: "",
        emailAddress: "",
        password: "",
        confirmPassword: "",
    };
    userId: Number = 0;
    async register() {
        this.registerModel.surname = this.registerModel.userName;
        this.registerModel.name = this.registerModel.userName;
        this.registerModel.emailAddress =
            this.registerModel.userName + "@golfreservations.club";
        (this.$refs.registerForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.spinShow = true;
                await Ajax.post(
                    "/api/services/app/Account/Register",
                    this.registerModel
                )
                    .then((res) => {
                        if (res && res.data && res.data.result) {
                            if (
                                res.data.result.canLogin == false &&
                                res.data.result.userId == -1
                            ) {
                                this.$Message.error({
                                    content: "该账号已存在,请使用账号密码登录",
                                });
                                 this.$router.push({ name: "login" });
                            } else {
                                this.userId = res.data.result.userId;
                                this.isNewCouponModal = true;
                                this.spinShow = false;
                                // this.$Message.success(this.L("RegisterSuccess"));
                                this.$Message.success({
                                    content: `注册成功`,
                                });
                                this.$router.push({ name: "login" });
                            }
                        }
                    })
                    .catch((err) => {
                        this.spinShow = true;
                    });
                // this.$router.push({ name: "login" });
            }
        });
    }
    goBack() {
        this.$router.go(-1);
    }
    mounted() {
        let domHtml = document.querySelector("html");
        domHtml.style.height = "100%";
        domHtml.style.width = "100%";
        let domBody = document.querySelector("body");
        domBody.style.height = "100%";
        domBody.style.width = "100%";
        let domApp = document.getElementById("app");
        domApp.style.height = "100%";
        this.wechatHandleClick();
    }
    wechatHandleClick() {
        let ba64Css = "css代码base64编码"; // 微信需要https的样式路径，这里将样式内容加密base64，可以避免使用https，如果你的网站是https的可以直接使用安官方文档使用css文件路径
        const appid = "wxd888b4544479f3af";
        const redirect_uri = encodeURIComponent(
            "https://golfreservations.club/login"
        );

        let loginObj = new WxLogin({
            id: "wxlogin", //div的id
            appid: appid,
            scope: "snsapi_login", //固定内容
            redirect_uri: redirect_uri, //回调地址
            // href: "http://*/static/UserCss/WeChart.css" //自定义样式链接，第三方可根据实际需求覆盖默认样式。
            //href: "data:text/css;base64," + ba64Css
            // state: "", //参数，可带可不带
            // style: "", //样式  提供"black"、"white"可选，默认为黑色文字描述
        });
    }
    validatePassConfirm(rule, value, callback) {
        if (value === "") {
            callback(new Error("请输入确认密码"));
        } else if (value !== this.registerModel.password) {
            callback(new Error("两次输入的密码不一致！"));
        } else {
            callback();
        }
    }
    rules = {
        userName: [
            {
                required: true,
                message: this.L("MobileNumber"),
                trigger: "blur",
            },
            {
                pattern: /^1[3456789]\d{9}$/,
                message: this.L(
                    "IncorrectFormat",
                    undefined,
                    this.L("MobileNumber")
                ),
                trigger: "blur",
            },
        ],
        password: [
            {
                required: true,
                message: this.L("PasswordRequired"),
                trigger: "blur",
            },
        ],
        confirmPassword: [
            {
                validator: this.validatePassConfirm,
                trigger: "blur",
            },
        ],
    };
}
